
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-7f07982a&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./SwappingSquaresSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./SwappingSquaresSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-7f07982a!../../../../vue-loader/lib/selector?type=template&index=0!./SwappingSquaresSpinner.vue"),
  /* scopeId */
  "data-v-7f07982a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/SwappingSquaresSpinner.vue
// module id = 875
// module chunks = 1